import { graphGet } from "@/helpers/api/apiGraph";

export const actions_mydrive = {
  async loadMyOneDriveRoot() {
    if (import.meta.env.VITE_BUILD_TARGET === "kkfiler") {
      return;
    }

    if (!this.myDriveRootIdString) {
      try {
        const response = await graphGet("/me/drive");
        this.myDriveRootIdString = response.id;

        this.driveTypeMap[response.id] = "OneDrive";
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }
};
